import React from 'react';
import { Popover, Tooltip, Button, Avatar } from 'antd';
import { SafetyOutlined } from '@ant-design/icons';
import toMaterialStyle from 'material-color-hash';
import { Link, useNavigate } from 'react-router-dom';
import { logoutActiveUser } from 'src/redux/actions/activeUserActions';
import { createUseStyles } from 'react-jss';
import { useTranslation } from 'react-i18next';
import store from 'src/redux/store/reduxStoreIndex';

const useStyles = createUseStyles({
	contentDiv: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
	avatar: {
		position: 'relative',
		bottom: '1px',
	},
});

const MyAvatar = (props) => {
	const { username, adminAccess, userId, resetError } = props;
	const avatarBackgroundColor = toMaterialStyle(username, 800).backgroundColor;

	const navigate = useNavigate();
	const classes = useStyles(avatarBackgroundColor);
	const { t } = useTranslation();

	const logoutUser = async () => {
		const url = window.location.pathname;
		await new Promise((resolve) => {
			store.dispatch(logoutActiveUser(userId));
			setTimeout(resolve, 500);
		});

		// Reload the site
		if (url === '/') {
			window.location.reload();
		}
	};
	return (
		<Popover
			placement='bottomRight'
			title={
				<div>
					{username}
					{adminAccess && (
						<Tooltip
							title={
								<div>
									{t('modelSelectView.lgin', '*Login status')}
									{': '}
									{t(['common:modelSelectView.loga', '*logged in as'])} {username}
								</div>
							}
						>
							<SafetyOutlined />
						</Tooltip>
					)}
				</div>
			}
			content={
				<div onClick={resetError ? resetError : undefined} className={classes.contentDiv}>
					<Link to='/userProfile'> {t('navbar.userSettings', '*User Settings')} </Link>

					<Button onClick={logoutUser} key='logout'>
						{t('modelSelectView.lgot', 'logout')}
					</Button>
				</div>
			}
			trigger='click'
		>
			<Avatar className={classes.avatar} size='large'>
				{`${username}`.toUpperCase().slice(0, 2)}
			</Avatar>
		</Popover>
	);
};

export default MyAvatar;
